export default __webpack_public_path__ + "static/media/gallery10.3344cf54.jpg";